module.exports = __webpack_public_path__ + "static/media/car2.3fd0be52.gif";